import React, { useState, useEffect } from "react";
import { Spin } from "antd";
import { ErrorMessage, FormikProvider, useFormik } from "formik";
import * as Yup from "yup";
import { Col, Form, Row } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { post, postFormData } from "../../../helpers/api_helper";

import {
  errorMessage,
  successMessage,
  warningMessage,
} from "../CommonFunctions";
import {
  POST_GetBranchDetailByID,
  POST_MachineResultCSVFileImport,
} from "../../../helpers/url_helper";

const MachineResultCSVFileImport = () => {
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);

  const AuthUser = JSON.parse(localStorage.getItem("userDetails"));

  const validationSchema = Yup.object().shape({
    CSVFileImport: Yup.string().required("File is required field"),
  });

  const formik = useFormik({
    validationSchema,
    onSubmit: (values, formikHelpers) =>
      handleValidSubmit(values, formikHelpers),
    initialValues: {
      CSVFileImport: "",
      UploadFileKey: "",
      MachinResultCSVFileTCNoColumnName: "",
      MachinResultCSVFileTestCountColumnName: "",
    },
    validateOnBlur: false,
  });

  const {
    values: { UploadFileKey },
  } = formik;

  const handleValidSubmit = (values) => {
    setIsLoading(true);

    let formData = new FormData();

    formData.append(
      "MachinResultCSVFileTCNoColumnName",
      values?.MachinResultCSVFileTCNoColumnName
    );
    formData.append(
      "MachinResultCSVFileTestCountColumnName",
      values?.MachinResultCSVFileTestCountColumnName
    );
    formData.append("CSVFileImport", values?.CSVFileImport);
    formData.append("CompanyIDEncrypted", AuthUser?.CompanyIDEncrypt);
    formData.append("BranchIDEncrypted", AuthUser?.BranchIDEncrypt);
    formData.append(
      "CreatedByEncrypted",
      AuthUser?.ReferenceIDEncrypt ? AuthUser?.ReferenceIDEncrypt : "0"
    );

    postFormData(POST_MachineResultCSVFileImport, formData)
      .then((response) => {
        setIsLoading(true);
        if (response?.IsSuccess) {
          successMessage(response?.Message);
          setTimeout(() => {
            navigate("/dashboard");
          }, 1000);
        } else {
          errorMessage(response?.Message);
        }
        setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  useEffect(() => {
    getBranchDetailsByID();
  }, []);

  const getBranchDetailsByID = () => {
    setIsLoading(true);
    post(POST_GetBranchDetailByID, {
      BranchIDEncrypt: AuthUser?.BranchIDEncrypt,
    })
      .then((response) => {
        if (response?.IsSuccess) {
          formik.setFieldValue(
            "MachinResultCSVFileTCNoColumnName",
            response?.MachinResultCSVFileTCNoColumnName
          );
          formik.setFieldValue(
            "MachinResultCSVFileTestCountColumnName",
            response?.MachinResultCSVFileTestCountColumnName
          );
        }
        setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  const uploadCSVFile = (e) => {
    if (e?.target?.files[0]) {
      const file = e?.target?.files[0];
      var pattern = /csv-*/;

      if (!e?.target?.files[0].type.match(pattern)) {
        warningMessage("Please Select valid CSV file!");
        formik.setFieldValue("CSVFileImport", "");
        formik.setFieldValue(
          "UploadFileKey",
          Math.random().toString(9).substring(2, 9)
        );
      } else {
        formik.setFieldValue("CSVFileImport", file);
      }
    }
  };

  return (
    <div className="card m-1">
      <div className="card-body p-1">
        <Spin
          size="large"
          spinning={isLoading}
          tip={"Loading..."}
          style={{ position: "fixed" }}
        >
          <div className="tbl-caption p-2">
            <h4 className="heading mb-0">Machine Result CSV File Import</h4>
          </div>
          <hr className="mt-0 mb-1"></hr>
          <div className="p-2 pt-0">
            <FormikProvider value={formik}>
              <Form onSubmit={formik.handleSubmit}>
                <Row>
                  <Col lg={3}>
                    <div className="d-flex justify-content-between">
                      <label className="mb-1">
                        CSV File <span className="text-danger">*</span>
                      </label>
                    </div>

                    <input
                      type="file"
                      id="CSVFileImport"
                      accept=".csv"
                      className="form-control form-control-sm"
                      key={UploadFileKey || ""}
                      onChange={(e) => {
                        uploadCSVFile(e);
                      }}
                    />
                    <ErrorMessage
                      name="CSVFileImport"
                      component="div"
                      className="invalid-feedback animated fadeInUp"
                      style={{ display: "block" }}
                    />
                  </Col>
                </Row>

                <div className="stickyBottomButtons">
                  <hr className="mt-1 mb-2"></hr>

                  <button type="submit" className="btn btn-primary btn-sm me-2">
                    <i className="fa-solid fa-floppy-disk"></i> Submit
                  </button>
                  <button
                    type="button"
                    className="btn btn-danger btn-sm"
                    onClick={(e) => {
                      navigate(-1);
                    }}
                  >
                    <i className="fa fa-cancel"></i> Cancel
                  </button>
                </div>
              </Form>
            </FormikProvider>
          </div>
        </Spin>
      </div>
    </div>
  );
};

export default MachineResultCSVFileImport;
